import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Dashboard, Href } from "../../../../Constants/Constants";

const BasicDemo = () => {
  const [open, setOpen] = useState(false);
  return (
    <ButtonGroup>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)} direction="down">
        <DropdownToggle color="primary" caret>
          {Dashboard}
        </DropdownToggle>
        <DropdownMenu className="dropdown-block">
          <DropdownItem href={Href}>{"Project"}</DropdownItem>
          <DropdownItem href={Href}>{"Ecommerce"}</DropdownItem>
          <DropdownItem href={Href}>{"Crypto"}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};
export default BasicDemo;
